import * as React from 'react';
export const Dropper = ({ image, width = 300, height = 150, className = 'react-dropper', onChange = () => undefined }) => {
    const canvas = React.createRef();
    const drawImage = React.useCallback(() => {
        const imageElement = new Image();
        imageElement.onload = () => {
            if (canvas.current?.getContext('2d')) {
                canvas.current.getContext('2d')?.drawImage(imageElement, 0, 0, width, height);
            }
        };
        imageElement.src = image;
        imageElement.crossOrigin = 'Anonymous';
    }, [image, width, height, canvas]);
    const getImageData = React.useCallback((e) => {
        const target = e.target;
        if (target?.getContext('2d')) {
            const offset = target.getBoundingClientRect();
            const canvasX = Math.floor(e.pageX - offset.left);
            const canvasY = Math.floor(e.pageY - offset.top);
            const imageData = target.getContext('2d')?.getImageData(canvasX, canvasY, 1, 1);
            return imageData?.data;
        }
    }, []);
    const setColor = React.useCallback((e) => {
        e.preventDefault();
        const data = getImageData(e);
        if (!data?.length) {
            onChange('', '');
            return;
        }
        const [r, g, b] = data;
        const newColor = `#${(b + 256 * g + 65536 * r).toString(16)}`;
        onChange(newColor, e.type);
    }, [onChange, getImageData]);
    React.useEffect(() => {
        drawImage();
    }, []);
    return (React.createElement("canvas", { ref: canvas, width: width, height: height, className: className, onClick: setColor, onMouseMove: setColor }));
};
export default Dropper;
//# sourceMappingURL=index.js.map